import { render, staticRenderFns } from "./chat-window-header.vue?vue&type=template&id=12f63ed6&scoped=true&"
import script from "./chat-window-header.vue?vue&type=script&lang=js&"
export * from "./chat-window-header.vue?vue&type=script&lang=js&"
import style0 from "./chat-window-header.vue?vue&type=style&index=0&id=12f63ed6&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12f63ed6",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VChip } from 'vuetify/lib/components/VChip';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VAvatar,VBtn,VChip,VTooltip})


/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('12f63ed6')) {
      api.createRecord('12f63ed6', component.options)
    } else {
      api.reload('12f63ed6', component.options)
    }
    module.hot.accept("./chat-window-header.vue?vue&type=template&id=12f63ed6&scoped=true&", function () {
      api.rerender('12f63ed6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/atendimento/components/chat-window-header/chat-window-header.vue"
export default component.exports